var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reconnect"},[_c('icon',{attrs:{"name":"exclamation-triangle"}}),_vm._v("  "+_vm._s(_vm.$t('Disconnected'))+" "),_c('div',{staticClass:"periods"},_vm._l((_vm.count),function(index){return _c('span',{key:index},[_vm._v(".")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }